export default __webpack_public_path__ + "static/media/enableEdit.4a124b40.svg";